export function buildSupplierProductUrl(supplierPrefix, product) {
  if (product?.supplier_url) {
    return product.supplier_url
  }

  if (String(supplierPrefix || '').toLowerCase() !== 'eany') {
    return null
  }

  const productId = firstProductIdentifier(
    product?.product_id_list,
    product?.product_id,
    product?.eany_product_id,
    product?.ean
  )

  return productId ? `https://eany.io/product/${encodeURIComponent(productId)}` : null
}

function firstProductIdentifier(...values) {
  for (const value of values) {
    const normalized = normalizeIdentifier(value)
    if (normalized) {
      return normalized
    }
  }
  return null
}

function normalizeIdentifier(value) {
  if (Array.isArray(value)) {
    return firstProductIdentifier(...value)
  }

  if (value === null || value === undefined) {
    return null
  }

  const raw = String(value).trim()
  if (!raw || raw === '-' || raw.toLowerCase() === 'n/a') {
    return null
  }

  if (raw.startsWith('[') && raw.endsWith(']')) {
    try {
      return normalizeIdentifier(JSON.parse(raw))
    } catch {
      // Fall through to token parsing.
    }
  }

  return raw
    .replace(/^["']|["']$/g, '')
    .split(/[,\s;|]+/)
    .map(part => part.trim())
    .find(Boolean) || null
}
